module.exports = __webpack_public_path__ + "img/layout-1.28068e57.jpg";